import React from 'react'
import { SelectArrayInputProps } from 'types/common'
import LocalizedSelectArrayInput from 'ui-shared/LocalizedFields/LocalizedSelectArrayInput'

const KLocalizedSelectArrayInput: React.FC<SelectArrayInputProps> = ({
  defaultValue = [],
  ...rest
}) => <LocalizedSelectArrayInput defaultValue={defaultValue} {...rest} />
export default KLocalizedSelectArrayInput
